module.exports = __webpack_public_path__ + "static/media/trash-can-solid-full.fe75315c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trash-can-solid-full.svg
// module id = 263
// module chunks = 0